import { createAction } from '@ngrx/store'

export const loadIntegrations = createAction('[Integrations] Load Integrations')

export const clearIntegrationErrors = createAction('[Integrations] Clear Errors')

export * from './facebook-account.actions'
export * from './linkedin-account.actions'
